import * as React from "react";

import ClintInfo from "./client-info";
import SecuritySettings from "./SecuritySetting";

// css
import styles from "./setting.module.scss";

const ClientPortalSettings = (): React.JSX.Element => (
  <div className={styles.settingsContainer}>
    <ClintInfo />
    <SecuritySettings />
  </div>
);

export default ClientPortalSettings;
